<template>
  <v-form @submit="initialLogin" id="login_fields">
    <div class="flex layout-row pt-4" style="max-width: 700px;min-height:450px;">
      <ValidationObserver ref="LoginForm" v-slot="{ valid, pristine, reset }" class="layout-column flex">

        <div class="flex layout-column">
          <div class="px-10 pt-3 layout-column" v-if="twoFactor">
            <h2 class="white--text mb-0 mt-0">{{ $t('AUTH.TWO_FACTOR.LOGIN.TITLE') }}</h2>
            <span class="white--text mb-6 body-2">{{ $t('AUTH.TWO_FACTOR.LOGIN.DESCRIPTION') }}</span>

            <div class="layout-column pt-3" style="border:1px solid white;border-radius:5px;background:rgba(255,255,255,0.15)">
              <code-input v-model="model.passcode" ref="codeInput" :enter-func="initialLogin" :error-reset-func="resetErrors" :style-version="1"></code-input>
            </div>
<!--        TODO auskommentiert bis trust token handling im backend bzw frontend implementiert ist -->
<!--            <div class="layout-row layout-align-start-center pb-0 pt-4" v-if="twoFactor && !loginError">-->
<!--              <v-checkbox color="pink"-->
<!--                          v-model="model.trust"-->
<!--                          hide-details-->
<!--                          class="ma-0 pa-0"-->
<!--                          dark>-->
<!--                <template slot="label">-->
<!--                  <span class="white&#45;&#45;text body-2">{{ $t('AUTH.TWO_FACTOR.LOGIN.TRUST_BROWSER') }} <small>({{ $t('AUTH.TWO_FACTOR.LOGIN.TRUST_BROWSER_HINT') }})</small></span>-->
<!--                </template>-->
<!--              </v-checkbox>-->
<!--            </div>-->
          </div>

          <div class="px-8 pt-5 layout-column" v-show="!twoFactor">
            <validation-provider tag="div" ref="Benutzername" name="Benutzername" rules="required" v-slot="{ errors }">
              <v-text-field
                :disabled="getCookieQuestionVisibility.visibility"
                v-model="model.login"
                :error-messages="errors[0]"
                color="white"
                dark
                outlined
                autofocus
                prepend-inner-icon="supervised_user_circle"
                :label="$t('AUTH.LOGIN.USERNAME')"
                placeholder=" "
                class="mx-2 white--text"
              ></v-text-field>
            </validation-provider>
            <validation-provider tag="div" ref="Passwort" name="Passwort" rules="required" v-slot="{ errors }">
              <v-text-field
                :disabled="getCookieQuestionVisibility.visibility"
                autocomplete="off"
                v-model="model.password"
                :error-messages="errors[0]"
                color="white"
                prepend-inner-icon="fingerprint"
                :label="$t('AUTH.LOGIN.PASSWORD')"
                dark
                outlined
                placeholder=" "
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                :hint="$t('AUTH.LOGIN.PASSWORD_HINT')"
                @click:append="showPassword = !showPassword"
                class="mx-2 mt-4"
              ></v-text-field>
            </validation-provider>
          </div>

          <div class="layout-row my-5 py-0 mx-10 px-3 red accent-2 white--text layout-align-start-center"
               style="border-left: 8px solid #d83b3b !important;border-radius: 3px;"
               v-if="(!twoFactor && loginError && !pristine) || (twoFactor && loginError)">
            <v-avatar>
              <v-icon dark>mdi-shield-lock</v-icon>
            </v-avatar>
            <div class="flex layout-column layout-align-start-center ml-2">
              <p class="ma-0">{{ $t('AUTH.LOGIN.LOGIN_INCORRECT') }}</p>
            </div>
          </div>
        </div>

        <v-divider class="mx-5"></v-divider>

        <div class="pa-2 d-flex flex-row">
          <div class="grow mr-1" v-if="twoFactor">
            <lx-btn classes="mr-1 text-none"
                    type="submit"
                    color="green"
                    block
                    :disabled="!model || !model.passcode || model.passcode.length < 6"
                    :label="$t('AUTH.LOGIN.BUTTONS.TWO_FACTOR')"
                    :tooltip="$t('AUTH.LOGIN.BUTTONS.TWO_FACTOR_HINT')"></lx-btn>
          </div>
          <div class="grow mr-1" v-else>
            <div class="grow">
              <lx-btn classes="mr-1 text-none"
                      type="submit"
                      color="green"
                      block
                      :disabled="!valid || pristine || getCookieQuestionVisibility.visibility"
                      :label="$t('AUTH.LOGIN.BUTTONS.LOGIN')"
                      :tooltip="$t('AUTH.LOGIN.BUTTONS.LOGIN_HINT')"></lx-btn>
            </div>
          </div>
          <lx-btn classes="mr-1 text-none"
                  @click="clearForm(reset)"
                  color="white"
                  :disabled="pristine"
                  icon="clear"
                  :tooltip="$t('AUTH.LOGIN.BUTTONS.CLEAR_HINT')"></lx-btn>
        </div>
      </ValidationObserver>
    </div>

  </v-form>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import CodeInput from '../components/CodeInput'
import moment from 'moment'

const LOCAL_STORE = process.env.VUE_APP_BASE_NAME + '-trust-token'

export default Vue.component('LoginComponent', {
  name: 'LoginComponent',
  props: ['test'],
  components: {
    CodeInput
  },
  data () {
    return {
      twoFactor: false,
      count: 0,

      model: {},
      showPassword: false,
      messageStr: '',
      loading: false,
      loginError: false,

    }
  },
  created () {
    if (this.$refs.LoginForm) {
      this.$refs.LoginForm.reset()
    }
  },
  computed: {},
  methods: {
    initialLogin (ev) {
      this.loading = true
      this.ResetMessaging()

      ev.preventDefault() // wichtig damit Formular mit Enter abgeschickt werden kann

      let trusted = JSON.parse(window.localStorage.getItem(LOCAL_STORE))

      if (trusted && trusted.expire && trusted.token) {
        let timeNow = moment()
        let expireTime = moment(trusted.expire)

        if (expireTime.isAfter(timeNow)) {
          this.model.trust_token_id = trusted.token
        } else {
          window.localStorage.removeItem(LOCAL_STORE)
        }
      }

      axios.post('/login', this.model)
        .then(resLogin => {
          if (resLogin.data && resLogin.data.trust_token_id) {
            let trusted = {
              token: resLogin.data.trust_token_id,
              expire: resLogin.data.trust_token_expire
            }
            window.localStorage.setItem(LOCAL_STORE, JSON.stringify(trusted))
          }

          // Login in auth store
          this.authStore.dispatch('login', { data: resLogin.data, type: 'login' })
          this.model = {} // falls man sich in der anwendung erneut einloggen muss damit die name und pwd nicht vom letzten versuich drin stehen
          this.twoFactor = false
          this.resetErrors()

          if (this.$refs['codeInput']) {
            this.$refs['codeInput'].resetSingleFields()
          }
          if (this.$refs.ReLoginForm) {
            this.$refs.ReLoginForm.reset()
          }
        })
        .catch(error => {
          let errorMsg = error.message

          if (errorMsg.indexOf('406') >= 0) {
            this.twoFactor = true
            this.resetErrors()
          } else {
            this.error = errorMsg
            this.loginError = true
            if (this.$refs.ReLoginForm) {
              this.$refs.ReLoginForm.reset()
            }
            if (this.twoFactor) {
              this.model.passcode = null
              this.$refs['codeInput'].resetSingleFields()
            } else {
              this.model = {}
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    resetErrors () {
      this.loginError = false
    },

    clearForm (reset) {
      reset()
      this.twoFactor = false
      this.resetErrors()
      this.model = {}

      if (this.$refs.codeInput) {
        this.$refs.codeInput.resetSingleFields()
      }
    }
  }
})
</script>
